import { render, staticRenderFns } from "./upload-related-video-drawer.vue?vue&type=template&id=00b7919e&scoped=true"
import script from "./upload-related-video-drawer.vue?vue&type=script&lang=js"
export * from "./upload-related-video-drawer.vue?vue&type=script&lang=js"
import style0 from "./upload-related-video-drawer.vue?vue&type=style&index=0&id=00b7919e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7919e",
  null
  
)

export default component.exports